// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.session-container {
  margin-top: 3.2rem;
  padding: 0 1rem;
  width: 100%;
  height: calc(100vh - 3.2rem);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 2rem;
}

.inner-pos-box {
  margin-top: 20px;
  margin-right: 20px;
}

.main-display-wrapper-box {
  /* width: 80% !important; */
  background-color: #fff;
  box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;
  border-radius: 10px;
  /* height: 65vh; */
  /* margin: auto; */
  max-width: 50rem;
  min-height: 30rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.dark .main-display-wrapper-box {
  background-color: #353a50;
}

.display-wrapper-box {
  border-radius: 7px;
  height: 1rem;
  margin: 3rem 7rem;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.main-session-box {
  left: 50%;
  background-color: #fff;
  border-radius: 7px;
  /* height: 22rem; */
  display: flex;
  flex-direction: column;
  align-content: center;
  justify-content: center;
  border-radius: 10px;
  align-items: center;
}

.dark .main-session-box {
  background-color: #353a50;
  color: #fff;
}

.dark .start-session-heading {
  color: #fff;
}`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/sessionPage/sessionPage.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,sBAAsB;EACtB,yFAAyF;EACzF,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;EACE,SAAS;EACT,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,WAAW;AACb","sourcesContent":[".session-container {\n  margin-top: 3.2rem;\n  padding: 0 1rem;\n  width: 100%;\n  height: calc(100vh - 3.2rem);\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 2rem;\n}\n\n.inner-pos-box {\n  margin-top: 20px;\n  margin-right: 20px;\n}\n\n.main-display-wrapper-box {\n  /* width: 80% !important; */\n  background-color: #fff;\n  box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;\n  border-radius: 10px;\n  /* height: 65vh; */\n  /* margin: auto; */\n  max-width: 50rem;\n  min-height: 30rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.dark .main-display-wrapper-box {\n  background-color: #353a50;\n}\n\n.display-wrapper-box {\n  border-radius: 7px;\n  height: 1rem;\n  margin: 3rem 7rem;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n}\n\n.main-session-box {\n  left: 50%;\n  background-color: #fff;\n  border-radius: 7px;\n  /* height: 22rem; */\n  display: flex;\n  flex-direction: column;\n  align-content: center;\n  justify-content: center;\n  border-radius: 10px;\n  align-items: center;\n}\n\n.dark .main-session-box {\n  background-color: #353a50;\n  color: #fff;\n}\n\n.dark .start-session-heading {\n  color: #fff;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
